import * as React from "react";
const IconShare = ({ fill = "#212A3D", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "1em"}
    height="1em"
    fill={fill}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M18 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-4 2a4 4 0 1 1 .983 2.626l-5.071 2.536a4 4 0 0 1 0 1.676l5.071 2.536a4 4 0 1 1-.895 1.788l-5.071-2.536a4 4 0 1 1 0-5.253l5.071-2.535A4 4 0 0 1 14 6m-8 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4m12 6a2 2 0 1 0-.001 4A2 2 0 0 0 18 16"
      clipRule="evenodd"
    />
  </svg>
);
export default IconShare;
